/**
 * Capitalize the first letter of a string
 * @param {string} str
 */
export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
